import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  NewStressCheckData,
  ActionType,
} from "models/stressCheck/newStressCheck";
import { IResponse } from "models";
import { httpStatus } from "configs/httpStatus";
import { saveNewStressCheck } from "services/stressCheck";
import { handleSuccesAction, handleErrorAction } from "./newStressCheckActions";

function* saveNewStressCheckSaga({ payload }: { payload: NewStressCheckData }) {
  try {
    const response: IResponse = yield call(saveNewStressCheck, payload);

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onSaveNewStressCheckWatcher() {
  yield takeLatest(ActionType.NEW_STRESS_CHECK as any, saveNewStressCheckSaga);
}

export default [fork(onSaveNewStressCheckWatcher)];
